class WishlistManager {
  constructor() {
    this.storageKey = "shopify_wishlist";
  }
  getWishlist() {
    try {
      const wishlist = localStorage.getItem(this.storageKey);
      return wishlist ? JSON.parse(wishlist) : [];
    } catch (error) {
      console.error("Error reading wishlist:", error);
      return [];
    }
  }
  addToWishlist(productId) {
    const wishlist = this.getWishlist();
    if (!wishlist.includes(productId)) {
      wishlist.push(productId);
      this.saveWishlist(wishlist);
      this.dispatchWishlistUpdate();
      return true;
    }
    return false;
  }
  removeFromWishlist(productId) {
    let wishlist = this.getWishlist();
    const index = wishlist.indexOf(productId);
    if (index > -1) {
      wishlist.splice(index, 1);
      this.saveWishlist(wishlist);
      this.dispatchWishlistUpdate();
      return true;
    }
    return false;
  }
  isInWishlist(productId) {
    return this.getWishlist().includes(productId);
  }
  saveWishlist(wishlist) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
    } catch (error) {
      console.error("Error saving wishlist:", error);
    }
  }
  dispatchWishlistUpdate() {
    window.dispatchEvent(new CustomEvent("wishlist:updated", {
      detail: { wishlist: this.getWishlist() }
    }));
  }
}
if (!window.wishlistManager) {
  window.wishlistManager = new WishlistManager();
}
class AddToWishlist extends window.HTMLElement {
  constructor() {
    super();
    this.productHandle = this.getAttribute("product-handle");
    this.textElement = null;
  }
  connectedCallback() {
    if (!this.productHandle) {
      console.error("product-handle attribute is required");
      return;
    }
    this.textElement = this.querySelector("[data-wishlist-text]");
    this.updateActiveState();
    this.addEventListener("click", this.handleClick.bind(this));
    window.addEventListener("wishlist:updated", this.updateActiveState.bind(this));
  }
  disconnectedCallback() {
    window.removeEventListener("wishlist:updated", this.updateActiveState.bind(this));
  }
  handleClick(e) {
    e.preventDefault();
    const isInWishlist = window.wishlistManager.isInWishlist(this.productHandle);
    if (isInWishlist) {
      window.wishlistManager.removeFromWishlist(this.productHandle);
    } else {
      window.wishlistManager.addToWishlist(this.productHandle);
    }
    this.updateActiveState();
  }
  updateActiveState() {
    const isInWishlist = window.wishlistManager.isInWishlist(this.productHandle);
    if (isInWishlist) {
      this.classList.add("active");
      this.setAttribute("aria-pressed", "true");
      const svg = this.querySelector("svg");
      if (svg) {
        svg.style.animation = "none";
        void svg.offsetHeight;
        svg.style.animation = "wishlist-bounce 0.4s ease";
      }
      if (this.textElement) {
        this.textElement.textContent = "Remove from Wishlist";
      }
    } else {
      this.classList.remove("active");
      this.setAttribute("aria-pressed", "false");
      if (this.textElement) {
        this.textElement.textContent = "Add to Wishlist";
      }
    }
  }
}
window.customElements.define("add-to-wishlist", AddToWishlist);
export {
  AddToWishlist as default
};
